/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityAssetTechData } from './ControlEntityAssetTechData';
import {
    ControlEntityAssetTechDataFromJSON,
    ControlEntityAssetTechDataFromJSONTyped,
    ControlEntityAssetTechDataToJSON,
} from './ControlEntityAssetTechData';

/**
 * 
 * @export
 * @interface ControlEntityAssetTechResult
 */
export interface ControlEntityAssetTechResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {ControlEntityAssetTechData}
     * @memberof ControlEntityAssetTechResult
     */
    data?: ControlEntityAssetTechData;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    tech_name?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ControlEntityAssetTechResult
     */
    cves?: Array<any>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityAssetTechResult
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    found?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetTechResult
     */
    version?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityAssetTechResult
     */
    category?: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityAssetTechResult interface.
 */
export function instanceOfControlEntityAssetTechResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityAssetTechResultFromJSON(json: any): ControlEntityAssetTechResult {
    return ControlEntityAssetTechResultFromJSONTyped(json, false);
}

export function ControlEntityAssetTechResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetTechResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'data': !exists(json, 'data') ? undefined : ControlEntityAssetTechDataFromJSON(json['data']),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'tech_name': !exists(json, 'tech_name') ? undefined : json['tech_name'],
        'cves': !exists(json, 'cves') ? undefined : json['cves'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'category': !exists(json, 'category') ? undefined : json['category'],
    };
}

export function ControlEntityAssetTechResultToJSON(value?: ControlEntityAssetTechResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'data': ControlEntityAssetTechDataToJSON(value.data),
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'tech_name': value.tech_name,
        'cves': value.cves,
        'shared': value.shared,
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
        'version': value.version,
        'category': value.category,
    };
}

